import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this._timeout = setTimeout(() => this.dismiss(), 5000)
  }

  disconnect() {
    if (this._timeout) clearTimeout(this._timeout)
  }

  dismiss() {
    this.element.remove()
  }
}
